import { render, staticRenderFns } from "./TabsSimple.vue?vue&type=template&id=3d9fcb1e&scoped=true"
import script from "./TabsSimple.vue?vue&type=script&lang=js"
export * from "./TabsSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9fcb1e",
  null
  
)

export default component.exports